<template>
  <v-flex
    layout
    align-center
    justify-center
    row
    :class="[
      langEdition !== locale && answerText[locale] && showHint
        ? 'showHintClass'
        : null,
    ]"
  >
    <p class="Position__font">
      {{ position }}
    </p>
    <v-text-field
      v-if="gameType === 'sort'"
      v-model="answerText[langEdition]"
      outline
      single-line
      @blur="updateAnswerText"
      :hint="langEdition !== locale ? answerText[locale] : null"
      :persistent-hint="showHint"
    >
      <language-translator
        v-if="locale !== langEdition"
        :langEdition="langEdition"
        :textToTranslate="answerText[locale]"
        :type="'answerText'"
        @text-translated="updateTranslatedText"
        slot="append"
      >
      </language-translator>
    </v-text-field>
    <image-input
      v-if="gameType === 'sortImage'"
      :default="answer.picture"
      :key="elementOrder"
      :showHint="showHint"
      :quizzImage="false"
      :langEdition="langEdition"
      @change-image-input="updateAnswerImage"
      @error="onImageError"
    ></image-input>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon
          v-if="possibleToDelete"
          v-on="on"
          color="red"
          class="pointerClass deleteIcon"
          @click="deleteAnswer()"
        >
          mdi-close
        </v-icon>
      </template>
      <span> {{ $t('gameSort.delete') }} </span>
    </v-tooltip>
  </v-flex>
</template>

<script>
import LanguageTranslator from '../components/LanguageTranslator.vue';
import ImageInput from './ImageInput';

export default {
  name: 'GameSort',
  components: {
    LanguageTranslator,
    ImageInput,
  },
  props: {
    elementOrder: {
      type: Number,
      default: null,
    },
    gameType: {
      type: String,
      default: null,
    },
    answer: {
      type: Object,
      default: null,
    },
    answerId: {
      type: Number,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    possibleToDelete: {
      type: Boolean,
      default: false,
    },
    langEdition: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      position: this.elementOrder + 1,
      answerText: '',
      isChosen: false,
    };
  },
  watch: {
    isDrag(newValue) {
      if (newValue === false) {
        this.isChosen = false;
      }
      return newValue;
    },
    answer(newValue) {
      this.answerText = newValue.text;
      return newValue;
    },
    gameType(newValue) {
      return newValue;
    },
  },
  created() {
    this.answerText = { fr: '', en: '' };
    this.answerText.en = this.answer.text.en;
    this.answerText.fr = this.answer.text.fr;
  },
  methods: {
    updateAnswerText() {
      if (
        this.answerText[this.langEdition] !== this.answer.text[this.langEdition]
      ) {
        this.$emit(
          'update-sort-answer',
          this.answerText[this.langEdition],
          this.elementOrder
        );
      }
    },
    updateAnswerImage(imageObject) {
      this.$emit('update-sort-answer', imageObject, this.elementOrder);
    },
    elementChosenToDrag() {
      this.isChosen = true;
      this.$emit('drag-button-sort-game-click');
    },
    deleteAnswer() {
      this.$emit('delete-answer', this.answerId, this.gameType);
    },
    async updateTranslatedText(textTranslated, type) {
      if (textTranslated) {
        if (type === 'answerText') {
          this.answerText[this.langEdition] = textTranslated;
          this.updateAnswerText();
        }
      }
    },
    onImageError(error) {
      console.log('imageError', error.message);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style scoped lang="sass">

div.v-input
 width: 300px
 height: 55px
 margin-bottom: 10px

div.v-text-field--outline>.v-input__control>.v-input__slot
  max-height: 40px;

.Position__key
  padding-left: 20px
  padding-top: 20px
.Position__font
  padding-right: 20px
.clickable
  cursor: pointer
.chosenClass
  background-color: rgb(224,224,224)
.deleteIcon
  max-width: 20px;
  position: absolute;
  left: 78%
.showHintClass
  margin-bottom: 20px;
</style>
